
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nos-services/[slug]",
      function () {
        return require("private-next-pages/nos-services/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nos-services/[slug]"])
      });
    }
  